<template>
  <div class="learning-container">
    <div v-if="!activeComponent" class="grid-container">
      <a-row :gutter="[16, 16]">
        <a-col :xs="24" :sm="12" :md="12" :lg="6" v-for="(card, index) in cards" :key="index">
          <a-card hoverable class="learning-card" :class="{'disabled-card': card.disabled}" @click="!card.disabled && selectComponent(card)">
            <div class="card-content text-center">
              <img :src="card.icon" class="card-icon" />
              <h4 class="card-title">{{ card.title }}</h4>
              <p v-if="card.disabled" class="coming-soon-text">Coming soon...</p>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>
    
    <div v-else class="detail-container">
      <div style="display: flex; align-items: center; margin-bottom: 24px; cursor: pointer;" @click="activeComponent = null">
        <a-icon type="arrow-left" style="font-size: 22px; margin-right: 12px; color: #1a1a2e;" />
        <h5 style="margin-bottom: 0; font-weight: 700; color: #1a1a2e; font-size: 20px;">{{ listData[activeIndex].title }}</h5>
      </div>
      <a-spin :spinning="loading">
        <component :is="activeComponent" :item="listData[activeIndex]" :contract-name-eng="contractNameEng"></component>
      </a-spin>
    </div>
  </div>
</template>

<script>
import HrdBudgetGuideline from './learning/HrdBudgetGuideline.vue';
import DevelopmentalRoadmap from './learning/DevelopmentalRoadmap.vue';
import IdpEssential from './learning/IdpEssential.vue';
import CareerGrowth from './learning/CareerGrowth.vue';

export default {
  props: {
    contractNameEng: {
      type: String,
      default: ''
    }
  },
  components: {
    HrdBudgetGuideline,
    DevelopmentalRoadmap,
    IdpEssential,
    CareerGrowth
  },
  data() {
    return {
      activeComponent: null,
      activeIndex: 0,
      loading: false,
      docs: [],
      cards: [
        { title: 'HRD Budget Guideline', icon: '/images/HRD_Budget.png', component: 'HrdBudgetGuideline', index: 0 },
        { title: 'Developmental Roadmap', icon: '/images/Developmental_Roadmap.png', component: 'DevelopmentalRoadmap', index: 1, disabled: true },
        { title: 'IDP Essential', icon: '/images/IDP_Essentials.png', component: 'IdpEssential', index: 2 },
        { title: 'Career Growth', icon: '/images/Roadmap.png', component: 'CareerGrowth', index: 3 },
      ],
      listData: [
        { title: 'HRD Budget Guideline', docs: [] },
        { title: 'Developmental Roadmap', docs: [] },
        { title: 'IDP Essential', docs: [] },
        { title: 'Career Growth', docs: [] },
      ]
    };
  },
  mounted() {
    this.fetchDocuments();
  },
  methods: {
    selectComponent(card) {
      this.activeComponent = card.component;
      this.activeIndex = card.index;
    },
    async fetchDocuments() {
      this.loading = true;
      try {
        const res = await this.$http.get('/hri/doc-file/');
        if (res.status === 200) {
          // HRD Budget Guideline
          let hrdDocs = res.data.filter(item => item.file_name && (
            item.file_name.endsWith('_HD_th_HD001') ||
            item.file_name.includes('_HD_th_HD001') ||
            /_HD_th_HD001/i.test(item.file_name)
          ));
          hrdDocs.sort((a, b) => 
            a.file_name.localeCompare(b.file_name, undefined, { numeric: true, sensitivity: 'base' })
          );
          this.listData[0].docs = hrdDocs.map((item, index) => ({
            key: String(index + 1),
            name: item.file_name.replace(/_HD_th_HD001.*$/i, '').replace(/_+$/, '').trim(),
            originalName: item.file_name,
            description: item.description || '-',
            link: item.doc_file ? item.doc_file : '#',
            updatedAt: item.updated_at
          }));

          // IDP
          let idpDocs = res.data.filter(item => item.file_name && item.file_name.includes('_IDP_'));
          idpDocs.sort((a, b) => 
            a.file_name.localeCompare(b.file_name, undefined, { numeric: true, sensitivity: 'base' })
          );
          this.listData[2].docs = idpDocs.map((item, index) => ({
            key: String(index + 1),
            name: item.file_name,
            description: item.description || '-',
            link: item.doc_file ? item.doc_file : '#',
            updatedAt: item.updated_at
          }));

          // Career Growth
          let cgDocs = res.data.filter(item => item.file_name && (item.file_name.includes('_CG_') || item.file_name.toLowerCase().includes('career') || item.file_name.toLowerCase().includes('advancement')));
          cgDocs.sort((a, b) => 
            a.file_name.localeCompare(b.file_name, undefined, { numeric: true, sensitivity: 'base' })
          );
          this.listData[3].docs = cgDocs.map((item, index) => ({
            key: String(index + 1),
            name: item.file_name,
            description: item.description || '-',
            link: item.doc_file ? item.doc_file : '#',
            updatedAt: item.updated_at
          }));
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.learning-container {
  padding: 0 20px;
}
.learning-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
}
.learning-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}
.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 10px;
}
.card-icon {
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 20px;
}
.card-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
}
.pl-0 { padding-left: 0; }
.mb-20 { margin-bottom: 20px; }
.mb-15 { margin-bottom: 15px; }
.pb-50 { padding-bottom: 50px; }

.disabled-card {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: auto;
}
.disabled-card:hover {
  transform: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}
.coming-soon-text {
  font-size: 13px;
  color: #ff4d4f;
  margin-top: 8px;
  font-weight: 700;
  font-style: italic;
  margin-bottom: 0;
}
</style>
